// addEventListener mandatory third parameter polyfill.
//
// On older browsers `Element.addEventListener` function requires third mandatory parameter. If you miss it, it will
// cause errors like NS_ERROR_XPC_NOT_ENOUGH_ARGS. Actual for Firefox 5.0 and more older browsers.
try {
  const c = () => {};
  window.addEventListener('error', c);
  window.removeEventListener('error', c);
} catch {
  try {
    [Element.prototype, Document.prototype, Window.prototype, document, window].forEach((el) => {
      // Store the original addEventListener method
      const originalAddEventListener = el.addEventListener;

      // Override addEventListener to always include the third parameter
      el.addEventListener = function (
        type: string,
        listener: EventListenerOrEventListenerObject,
        options?: boolean | AddEventListenerOptions,
      ) {
        // Call the original method with all three parameters
        return originalAddEventListener.call(this, type, listener, options || false);
      };
    });
    console.log('[Polyfills] addEventListener mandatory third parameter polyfill added.');
  } catch (error) {
    console.error('[Polyfills] addEventListener mandatory third parameter polyfill error', error);
  }
}
